import { appEvents } from "@/app/events/appEvents";

export abstract class BaseController<T = object> {
    protected $view: JQuery;
    private cssClass: string;
    protected controllerId: string;
    protected onDispose?: { () };

    constructor(cssClass: string) {
        this.controllerId = "controller-" + new Date().getTime();
        this.$view = $('<div id="' + this.controllerId + '" class="view ' + cssClass + '" />').data("ctrl", this);
        this.cssClass = cssClass;
    }

    public show(transition?: ViewTransition, param?: T) {
        if (this.$view.length === 0) {
            console.error(`View ${this.cssClass} not found`);
        }

        //hide other controllers
        const activeCtrls = this.$view.parent().find("> .view.shown");
        if (activeCtrls.length > 0) {
            if (activeCtrls.is(this.$view)) return;

            //remove all transitions
            activeCtrls.addClass("notransition shown").removeClass("animleft animright fadetransition fadeout")[0]
                .offsetHeight;

            if (transition !== undefined && transition === ViewTransition.SlideLeft)
                activeCtrls.removeClass("notransition shown").addClass("animleft");
            else if (transition !== undefined && transition === ViewTransition.SlideRight)
                activeCtrls.removeClass("notransition shown").addClass("animright");
            else if (transition !== undefined && transition === ViewTransition.Fade) {
                activeCtrls.addClass("fadetransition")[0].offsetHeight;
                activeCtrls.removeClass("notransition shown").addClass("fadeout");
            } else activeCtrls.removeClass("shown");

            appEvents.controller.hidden.dispatch();
            activeCtrls.data("ctrl").onBecomeInvisible(transition);
        }

        //remove all transitions
        this.$view.addClass("notransition").removeClass("animleft shown animright fadetransition fadeout");

        if (transition !== undefined && transition === ViewTransition.SlideLeft) {
            this.$view.addClass("animright")[0].offsetHeight;
            this.$view.removeClass("notransition animright").addClass("shown");
        } else if (transition !== undefined && transition === ViewTransition.SlideRight) {
            this.$view.addClass("animleft")[0].offsetHeight;
            this.$view.removeClass("notransition animleft").addClass("shown");
        } else if (transition !== undefined && transition === ViewTransition.Fade) {
            this.$view.addClass("fadetransition fadeout")[0].offsetHeight;
            this.$view.removeClass("notransition fadeout").addClass("shown");
        } else this.$view.addClass("shown");

        appEvents.controller.shown.dispatch(this.controllerId);
        this.onBecomeVisible(param, transition);
    }

    public stackTo($container: JQuery) {
        this.$view.appendTo($container);
    }

    public isVisible(): boolean {
        return this.$view.hasClass("shown");
    }

    public async dispose() {
        if (this.onDispose) {
            await this.onDispose();
        }
        this.$view.remove();
    }

    public static getActiveCtrl($container: JQuery): BaseController | undefined {
        const active = $container.find("> .view.shown");
        if (active.length === 0) return undefined;

        if (active.length > 1) return active.last().data("ctrl");

        return active.data("ctrl");
    }

    protected abstract onBecomeVisible(param?: T, transition?: ViewTransition);
    protected abstract onBecomeInvisible(transition?: ViewTransition);
}

export enum ViewTransition {
    SlideLeft,
    SlideRight,
    Fade,
}
